export default "__VITE_ASSET__D1fvO9_x__"